theme.AssetsLoader.onPageLoaded(function() {
  if(window.innerWidth < 800) {
      jQuery('.banner-bottom-info .container > .row').slick({
          items: 1,
          autoplay: true,
          dots: false,
          arrows: false,
          autoplaySpeed: 1500
      })
  }
});

